/**
 * MapLibre layer and source identifiers for dev-only debug overlays (Layers modal).
 */

/** Prefix for per-vehicle route line layers. */
export const BUS_ROUTE_LINE_LAYER_PREFIX = "vehicle-line-layer-";

/** Prefix for per-vehicle route line GeoJSON sources. */
export const BUS_ROUTE_LINE_SOURCE_PREFIX = "vehicle-line-source-";

/** Prefix for per-vehicle route point layers (reserved; symbol layer currently disabled). */
export const BUS_ROUTE_POINT_LAYER_PREFIX = "vehicle-point-layer-";

/** Prefix for per-vehicle route point GeoJSON sources. */
export const BUS_ROUTE_POINT_SOURCE_PREFIX = "vehicle-point-source-";

/** Prefix for per-vehicle direction arrow layers. */
export const BUS_ROUTE_ARROW_LAYER_PREFIX = "vehicle-arrow-layer-";

/** Prefix for per-vehicle direction arrow GeoJSON sources. */
export const BUS_ROUTE_ARROW_SOURCE_PREFIX = "vehicle-arrow-source-";

/** GeoJSON source for stop preload bbox debug polygon. */
export const STOPS_DEBUG_BBOX_SOURCE_ID = "stops-debug-bbox-source";

/** Fill layer for stop preload bbox debug polygon. */
export const STOPS_DEBUG_BBOX_FILL_LAYER_ID = "stops-debug-bbox-fill";

/** Outline layer for stop preload bbox debug polygon. */
export const STOPS_DEBUG_BBOX_LINE_LAYER_ID = "stops-debug-bbox-line";

/** GeoJSON source for stop preload shrink (comfort) zone debug polygon. */
export const STOPS_DEBUG_SHRINK_SOURCE_ID = "stops-debug-shrink-source";

/** Fill layer for stop preload shrink debug polygon. */
export const STOPS_DEBUG_SHRINK_FILL_LAYER_ID = "stops-debug-shrink-fill";

/** Outline layer for stop preload shrink debug polygon. */
export const STOPS_DEBUG_SHRINK_LINE_LAYER_ID = "stops-debug-shrink-line";

/** Layer id prefixes removed by {@link removeBusRouteShapesFromMap}. */
export const BUS_ROUTE_DEBUG_LAYER_PREFIXES = [
    BUS_ROUTE_LINE_LAYER_PREFIX,
    BUS_ROUTE_POINT_LAYER_PREFIX,
    BUS_ROUTE_ARROW_LAYER_PREFIX,
] as const;

/** Source id prefixes removed by {@link removeBusRouteShapesFromMap}. */
export const BUS_ROUTE_DEBUG_SOURCE_PREFIXES = [
    BUS_ROUTE_LINE_SOURCE_PREFIX,
    BUS_ROUTE_POINT_SOURCE_PREFIX,
    BUS_ROUTE_ARROW_SOURCE_PREFIX,
] as const;

/**
 * Builds per-vehicle bus route debug layer and source ids.
 *
 * @param vehicleId Vehicle identifier.
 * @returns Stable MapLibre ids for line, point, and arrow overlays.
 */
export const buildBusRouteDebugIds = ( vehicleId: string ): {
    "lineSourceId":  string;
    "lineLayerId":   string;
    "pointSourceId": string;
    "pointLayerId":  string;
    "arrowSourceId": string;
    "arrowLayerId":  string;
} => ( {
    "lineSourceId":  `${ BUS_ROUTE_LINE_SOURCE_PREFIX }${ vehicleId }`,
    "lineLayerId":   `${ BUS_ROUTE_LINE_LAYER_PREFIX }${ vehicleId }`,
    "pointSourceId": `${ BUS_ROUTE_POINT_SOURCE_PREFIX }${ vehicleId }`,
    "pointLayerId":  `${ BUS_ROUTE_POINT_LAYER_PREFIX }${ vehicleId }`,
    "arrowSourceId": `${ BUS_ROUTE_ARROW_SOURCE_PREFIX }${ vehicleId }`,
    "arrowLayerId":  `${ BUS_ROUTE_ARROW_LAYER_PREFIX }${ vehicleId }`,
} );
